import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

const TONE = {
  warn: "bg-amber-500/[0.08] text-amber-900 dark:text-amber-200",
  err: "bg-rose-500/10 text-rose-900 dark:text-rose-200",
};

type Props = {
  tone: "warn" | "err";
  title: string;
  body?: string;
  children?: ReactNode;
};

export function StepNote({ tone, title, body, children }: Props) {
  return (
    <div
      role={tone === "err" ? "alert" : "status"}
      className={cn(
        "grid grid-cols-[16px_minmax(0,1fr)] gap-2 rounded-lg px-3 py-2.5 text-[13px] leading-normal",
        TONE[tone],
      )}
    >
      <span aria-hidden className="font-bold">
        {tone === "err" ? "✕" : "!"}
      </span>
      <div className="min-w-0 space-y-1.5">
        <p>
          <b>{title}</b> {body}
        </p>
        {children}
      </div>
    </div>
  );
}
